// extracted by LIB_CSS_EXTRACT_LOADER
import "./card_module.css"
export default {"card":"card-_owfM_","header":"header-Mb1uO1","title":"title-_JHGWK","description":"description-g0aJ8n","action":"action-dE6pol","content":"content-CUpArl","footer":"footer-fIXQhx"};